import {
  ListItem,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import CustomRating from '../../../../../components/CustomRating';
import CustomTextField from '../../../../../components/CustomTextField';
import { XCircle } from '../../../../../icons/x-circle';
import STRING_KEYS from '../../../../../language/keys';
import ErrorMessage from '../../../../../components/ErrorMessage';
import { Validations } from '../../../Constants';
import { VIEW_MODE } from '../../../../../consts/enums';
import { SkillItemStyle } from './style';

const RATING_DEFAULT_VALUE = 0;
const RATING_DEFAULT_PRECISION = 1;

type SkillItemProps = {
  id: string,
  name: string,
  level: number,
  onRemoveClick?: (id: string) => void,
  onItemChanged?: (updatedItem: Skills) => void,
  error:Skills | null,
  viewMode: ViewMode
}

export const SkillItem = ({
  id,
  name,
  level,
  onRemoveClick,
  onItemChanged = () => { /* todo */ },
  error,
  viewMode,
}:SkillItemProps): JSX.Element => {
  const {
    listItem,
    input,
    errorInput,
    errorListItem,
    textField,
    rating,
    removeButton,
    label,
  } = SkillItemStyle;
  const { t: translate } = useTranslation();

  const handleNameChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target) {
      onItemChanged({
        id,
        name: event.target.value,
        level,
      });
    }
  };

  const handleLevelChanged = (event: React.SyntheticEvent<Element, Event>,
    value: number | null) => {
    if (event.target) {
      onItemChanged({
        id,
        name,
        level: value || RATING_DEFAULT_VALUE,
      });
    }
  };

  const defineErrorMessage = () => {
    if (error && (error.name || error.level === RATING_DEFAULT_VALUE)) {
      return <ErrorMessage message={ error.name || Validations.Skills.Level.Message.text } />;
    }

    return null;
  };

  const canRemove = typeof onRemoveClick === 'function' && viewMode === VIEW_MODE.EDITABLE;

  return (
    <>
      <ListItem
        divider
        style={ error ? errorListItem : listItem }
      >
        <CustomTextField
          viewMode={ viewMode }
          id={ id }
          variant="standard"
          placeholder={ translate(STRING_KEYS.SKILLS_PLACEHOLDER) }
          InputProps={ {
            onChange: handleNameChanged,
            disableUnderline: true,
            style: error ? errorInput : input,
          } }
          sx={ textField }
          value={ name }
        />
        <Typography
          sx={ label.sx }
          style={ label.style }
        >{translate(STRING_KEYS.NOVICE)}
        </Typography>
        <CustomRating
          viewMode={ viewMode }
          name="rating"
          defaultValue={ RATING_DEFAULT_VALUE }
          precision={ RATING_DEFAULT_PRECISION }
          value={ level }
          onChange={ handleLevelChanged }
          style={ rating }
        />
        <Typography
          sx={ label.sx }
          style={ label.style }
        >{translate(STRING_KEYS.EXPERT)}
        </Typography>

        {canRemove && (
          <XCircle
            style={ removeButton.style }
            sx={ removeButton.sx }
            onClick={ () => onRemoveClick(id) }
          />
        )}
      </ListItem>
      { defineErrorMessage() }
    </>
  );
};

SkillItem.defaultProps = {
  onRemoveClick: undefined,
  onItemChanged: () => { /* todo */ },
};
